import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Box,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import SuiButton from "components/SuiButton";

import useUserRoles from "hooks/useUserRoles";

import EditProcesoJudicial from "./editProcesoJudicial";

import ProcesosApi from "api/procesosApi";

const TabProcesosJudiciales = ({ proceso }) => {
  const { user, roles } = useUserRoles();
  const [procesosJudiciales, setProcesosJudiciales] = useState([]);
  const [selectedProcesoJudicial, setSelectedProcesoJudicial] = useState(null);
  const [showProcesoJudicialModal, setShowProcesoJudicialModal] = useState(false);

  const fetchDatosIniciales = async () => {
    try {
      if (proceso.procesos_judiciales) {
        const procesosResponse = await ProcesosApi.obtenerProcesosJudiciales(proceso.id);
        setProcesosJudiciales(procesosResponse.data);
      }
    } catch (error) {
      console.error("Error al obtener los datos iniciales:", error);
    }
  };

  useEffect(() => {
    if (proceso) {
      fetchDatosIniciales();
    }
  }, [user, proceso]);

  const handleEliminarProcesoJudicial = async (proceso_judicial) => {
    if (window.confirm("¿Está seguro(a) de eliminar este Proceso Judicial?")) {
      try {
        await ProcesosApi.eliminarProcesoJudicial(proceso.id, proceso_judicial.id);
        fetchDatosIniciales();
      } catch (error) {
        console.error("Error al eliminar el Proceso Judicial.", error);
      }
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
        <Grid size={6} sx={{ mt: 1, display: "flex", justifyContent: "flex-start", gap: 2 }}>
          {(roles.isAdmin || roles.isCoordinador || roles.isOperador || roles.isDirector) && (
            <SuiButton
              variant="gradient"
              buttonColor="info"
              onClick={() => {
                setSelectedProcesoJudicial(null);
                setShowProcesoJudicialModal(true);
              }}
            >
              Agregar Proceso Judicial
            </SuiButton>
          )}
          <EditProcesoJudicial
            open={showProcesoJudicialModal}
            onClose={() => setShowProcesoJudicialModal(false)}
            proceso={proceso}
            proceso_judicial={selectedProcesoJudicial}
            onSuccess={() => {
              fetchDatosIniciales();
              setShowProcesoJudicialModal(false);
            }}
          />
        </Grid>
      </Grid>
      <Box sx={{ mt: 1 }}>
        <Grid container spacing={1}>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell sx={{ textAlign: "center", fontWeight: "bold", padding: "2px 2px" }}>
                    Opciones
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", fontWeight: "bold", padding: "2px 2px" }}>
                    Juzgado
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", fontWeight: "bold", padding: "2px 2px" }}>
                    Correo Electrónico
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", fontWeight: "bold", padding: "2px 2px" }}>
                    Demandante
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", fontWeight: "bold", padding: "2px 2px" }}>
                    Demandado
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", fontWeight: "bold", padding: "2px 2px" }}>
                    Radicado
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", fontWeight: "bold", padding: "2px 2px" }}>
                    Estado Actual
                  </TableCell>
                </TableRow>
                {procesosJudiciales.map((proceso_judicial) => (
                  <TableRow key={proceso_judicial.id}>
                    <TableCell sx={{ textAlign: "center", padding: "2px 2px" }}>
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                          setSelectedProcesoJudicial(proceso_judicial);
                          setShowProcesoJudicialModal(true);
                        }}
                        sx={{
                          mr: 1,
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.05)",
                          },
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          handleEliminarProcesoJudicial(proceso_judicial);
                        }}
                        sx={{
                          mr: 1,
                          "&:hover": {
                            backgroundColor: "rgba(255, 0, 0, 0.1)", // Un rojo suave al pasar el mouse
                          },
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                    <TableCell sx={{ padding: "2px 2px" }}>{proceso_judicial.juzgado}</TableCell>
                    <TableCell sx={{ padding: "2px 2px" }}>{proceso_judicial.email}</TableCell>
                    <TableCell sx={{ padding: "2px 2px" }}>{proceso_judicial.demandante}</TableCell>
                    <TableCell sx={{ padding: "2px 2px" }}>{proceso_judicial.demandado}</TableCell>
                    <TableCell sx={{ padding: "2px 2px" }}>{proceso_judicial.radicado}</TableCell>
                    <TableCell sx={{ padding: "2px 2px" }}>
                      {proceso_judicial.estado_actual}
                    </TableCell>
                    <TableCell sx={{ padding: "2px 2px" }}>
                      {proceso_judicial.afectaciones}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Box>
    </Box>
  );
};

TabProcesosJudiciales.propTypes = {
  proceso: PropTypes.object,
};

export default TabProcesosJudiciales;
